import Typography from '@mui/material/Typography';
import React, {Fragment} from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import './App.css';

export default function Heading(props) {
    return (
        <Fragment>
            {props.imageUrl === "null" ?
                <div className="heading">

                    <Typography variant="h4">
                        {props.text}
                    </Typography>
                </div>
                :
                <div className="heading">
                    <LazyLoadImage
                        alt={props.text}
                        src={props.imageUrl}
                        width="44"
                        height="44"
                        effect="blur" />
                    <Typography variant="h4">
                        {props.text}
                    </Typography>
                </div>
            }
        </Fragment>
    );
}